import { render, staticRenderFns } from "./VersionAssetsAdd.vue?vue&type=template&id=4c5eeed8&lang=pug"
import script from "./VersionAssetsAdd.vue?vue&type=script&lang=js"
export * from "./VersionAssetsAdd.vue?vue&type=script&lang=js"
import style0 from "./VersionAssetsAdd.vue?vue&type=style&index=0&id=4c5eeed8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports